import { Component } from '@angular/core';
import { ExtraFieldArray } from '../extra-field-array';
import * as _ from 'underscore';
import { GaFormlyUtil } from '../ga-formly.util';

@Component({
  selector: 'formly-field-array',
  template: `
    <div class="row" *ngFor="let ff of field?.fieldGroup; let idx = index;" [ngClass]="[getDefaultClassName(idx), (ff.templateOptions.fieldArrayWrapperClass || to.fieldArrayWrapperClass || '')]">
      <formly-field class="col" [field]="ff" [ngClass]="ff.templateOptions.fieldArrayControlClass || to.fieldArrayControlClass"></formly-field>
      <div class="col-sm-3 d-flex align-items-center" *ngIf="showFieldArrayButtons(idx)" [ngClass]="ff.templateOptions.fieldArrayButtonsClass || to.fieldArrayButtonsClass || 'text-end'">
        <button class="btn btn-default" (click)="remove(idx)"><i class="icon fa fa-trash-o margin-right-xs"></i> <span translate>GA.BUTTONS.DELETE</span></button>
      </div>
    </div>
  `
})
export class FormlyFieldArrayComponent extends ExtraFieldArray {
  constructor(
    private formlyUtil:GaFormlyUtil
  ) {
    super();
  }

  public getDefaultClassName(index:number):string {
    return `field-array-${this.formlyUtil.createFieldArrayClassName(<string>this.key)}-${index}`;
  }

  public showFieldArrayButtons(index:number):boolean {
    if (_.isFunction(this.to.showFieldArrayButtons)) {
      return this.to.showFieldArrayButtons(this.model?.[index], this.formState, this.field);
    } else {
      return _.isUndefined(this.to.showFieldArrayButtons) ? true : this.to.showFieldArrayButtons;
    }
  }
}